module.exports = __webpack_public_path__ + "static/media/socialPiper-budget-tabletPro-en.a0aa0c47.png";